// @flow
import React from "react";
import styled, { css } from "styled-components";
import { isEmpty } from "lodash";
import { RichText as PrismicRichText } from "prismic-reactjs";
import {
  H1Styles,
  H2Styles,
  H3Styles,
  H4Styles,
  H6Styles,
  PStyles,
  AStyles,
  BStyles,
  EmbeddedImage,
} from "@nested/ui";

const RichTextStyles = styled.div`
  ${({ center }) =>
    center &&
    css`
      * {
        margin-left: auto;
        margin-right: auto;
        text-align: center;
      }
    `};

  h1 {
    ${H1Styles};
  }
  h2 {
    ${H2Styles};
  }
  h3 {
    ${H3Styles};
  }
  h4 {
    ${H4Styles};
  }
  h6 {
    ${H6Styles};
  }
  p {
    ${PStyles};
  }
  a {
    ${AStyles};
  }
  li {
    ${PStyles}
  }
  strong {
    ${BStyles};
  }

  img {
    max-width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
  }
`;

type Props = {
  children: PrismicRichText,
  center?: boolean,
  className?: string,
  white?: boolean,
};

const replaceEmbeddedImage = (node, index) => {
  if (node.props["data-oembed-provider"] === "static_image") {
    return <EmbeddedImage key={index} src={node.props["data-oembed"]} />;
  }
  return node;
};

export const createResponsiveImages = (node: React$Element<any>) =>
  React.cloneElement(node, {}, node.props.children.map(replaceEmbeddedImage));

export const PlainText = ({ children }: Props) => RichText.asText(children);

export const hasContent = (text: PrismicRichText) =>
  text?.length > 0 && !isEmpty(text[0]);

export const RichText = ({ children, className, center }: Props) =>
  hasContent(children) && (
    <RichTextStyles className={className} center={center}>
      {createResponsiveImages(PrismicRichText.render(children))}
    </RichTextStyles>
  );
